class WishlistHeart extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.locked = false

    // Parse customer wishlist data
    this.productId = parseInt(this.dataset?.productId)
    this.variantId = parseInt(this.dataset?.variantId)

    // Store info about the item
    this.listId = null
    this.itemId = null

    this.fetchIds()

    if (this.listId && this.itemId) this.markActive()

    this.setInitialised()

    if (!this.hasBeenAdded) {
      if (
        window.location.hash === `#wishlist-${parseInt(this.dataset.variantId)}`
      ) {
        setTimeout(() => {
          this.click()
        }, 500)
      }
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onHeartClicked = this.onHeartClicked.bind(this)

    this.listeners.add(this, 'click', this.onHeartClicked)

    if (this.parentTrigger) {
      this.listeners.add(this.parentTrigger, 'click', this.onHeartClicked)
    }

    document.addEventListener('wishlist-item-removed', event => {
      const removedProductId = event.detail.productId

      if (this.dataset.productId === removedProductId) {
        this.markInactive()
      }
    })
  }

  async onHeartClicked (event) {
    event.preventDefault()

    // Early return when this button is for clothing sizes (on pdp) and no sizes are selected
    if (this.closest('[data-clothing-sizes-wishlist-button]')) {
      const radioEls = document.querySelectorAll(
        '[data-product-as-variant-el="radio"]',
      )
      if (
        radioEls.length &&
        !Array.from(radioEls).some(radioEl => radioEl.checked)
      ) {
        return
      }
    }

    if (this.token === '') {
      window.BAO.wishlist.redirectToLogin(`wishlist-${this.variantId}`)
      return
    }

    if (this.hasAttribute('site-modal-id')) {
      window.BAO.wishlist.activator = this
      this.requestModalOpen()
    } else {
      const modal = this.externalEls.modal.element
      modal.dataset.productId = this.dataset?.productId.toString()
      modal.dataset.variantId = this.dataset?.variantId.toString()
      modal.activator = window.BAO.wishlist.activator
        ? window.BAO.wishlist.activator
        : this

      return this.externalEls.modal.element.open()
    }
  }

  async removeFromWishlist () {
    await window.BAO.wishlist.removeItem(this.listId, this.itemId, this.token)

    this.listId = null
    this.itemId = null

    await window.BAO.wishlist.rerenderModal()

    this.locked = false
  }

  fetchIds () {
    // Loop all lists
    this.data.lists.every(list => {
      // Try and find the current item in the list
      const item = list.items.find(i => {
        if (
          String(i.product_id) === String(this.dataset?.productId) &&
          String(i.variant_id) === String(this.dataset?.variantId)
        ) {
          return true
        }

        if (
          this.dataset?.variantIds?.split(',')?.includes(String(i.variant_id))
        ) {
          return true
        }

        return false
      })

      if (item) {
        this.listId = list.id
        this.itemId = item.id
        return false
      }

      return true
    })
  }

  markActive () {
    this.classList.add('wlt-Heart-active')
  }

  markInactive () {
    this.classList.remove('wlt-Heart-active')
  }

  setInitialised () {
    this.setAttribute('data-initialised', 'true')
  }

  requestModalOpen () {
    this.dispatchEvent(
      new CustomEvent('site-modal:open', {
        bubbles: true,
        detail: { id: this.getAttribute('site-modal-id') },
      }),
    )
  }

  get active () {
    return this.classList.contains('wlt-Heart-active')
  }

  get token () {
    return window.BAO.wishlist.token
  }

  get data () {
    return window.BAO.wishlist.data
  }

  get hasBeenAdded () {
    return this.listId && this.itemId
  }

  get parentTrigger () {
    return this.closest('[data-wishlist-heart-parent-trigger]')
  }
}

customElements.define('wishlist-heart', WishlistHeart, {
  extends: 'button',
})
